import React from "react";
import { Row, Col } from "reactstrap";

import hyperdelta from "assets/img/hyperdrive/hyperdelta.gif";

const HyperDelta = ({isMobile}) => {
  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <h3 className="title" style={{ lineHeight: "150%", fontSize: '2.25em', marginTop: '20px' }}>HyperDelta&trade;</h3>
        <Row>
          <Col xs={12} lg={12} md={12} className="text-center d-flex align-items-center mb-4 mb-md-0 order-md-1 order-1">
            <p style={{ color: "white", fontSize: '1.25em', paddingLeft: isMobile ? '0em':'3.5em', paddingRight: isMobile ? '0em':'3.5em'}}>
            We put together a concept vehicle design and visualization based on the urban air mobility mission and concept of operations with the MagLev HyperDrive&trade; at the core. 
            This enables sweeping performance and economic improvements: increased payload capacity and reduced hover power requirements, lower acoustics, increased cruise and dash capabilities, increased flight operations tempo, decreased service and maintenance costs, and increased revenue per seat, trip, and vehicle.
            </p>
          </Col>
          <Col xs={12} lg={12} md={12} className="text-center d-flex align-items-center order-md-1 order-2">
            <div style={{ width: '100%', textAlign: 'center' }}>
              <img src={hyperdelta} alt="GIF animation of hyperdelta" style={{width:'60%'}}/>
            </div>
          </Col>
        </Row>
        <Row className="text-center justify-content-center mt-5" style={{ marginBottom: '20px' }}>
          <Col xs={12} lg={3} md={3}>
            <h3 style={{
              color: 'white',
              fontSize: '2em',
              fontWeight: 'bold',
              ...(isMobile && { fontSize: '1.5rem' }),
            }}>50%</h3>
            <h4 style={{ color: 'white', marginTop: '10px', fontSize: '1.25em'}}>More Passengers or Cargo</h4>
          </Col>
          <Col xs={12} lg={3} md={3}>
            <h3 style={{
              color: 'white',
              fontSize: '2em',
              fontWeight: 'bold',
              ...(isMobile && { fontSize: '1.5rem' }),
            }}>Up to 25+ dBA</h3>
            <h4 style={{ color: 'white', marginTop: '10px', fontSize: '1.25em'}}>Quieter than Helicopters</h4>
          </Col>
          <Col xs={12} lg={3} md={3}>
            <h3 style={{
              color: 'white',
              fontSize: '2em',
              fontWeight: 'bold',
              ...(isMobile && { fontSize: '1.5rem' }),
            }}>50%</h3>
            <h4 style={{ color: 'white', marginTop: '10px', fontSize: '1.25em'}}>Faster than Competitors</h4>
          </Col>
          <Col xs={12} lg={3} md={3}>
            <h3 style={{
              color: 'white',
              fontSize: '2em',
              fontWeight: 'bold',
              ...(isMobile && { fontSize: '1.5rem' }),
            }}>Up to 2.3x</h3>
            <h4 style={{ color: 'white', marginTop: '10px', fontSize: '1.25em'}}>More Flights per Vehicle</h4>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HyperDelta;
